import { render, staticRenderFns } from "./HomeShopkeeper.vue?vue&type=template&id=29e42ff6&"
import script from "./HomeShopkeeper.vue?vue&type=script&lang=js&"
export * from "./HomeShopkeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports